import {
  PERMANENT_PURCHASE_DEFINITIONS,
  type PermanentPurchaseDefinition,
} from "@/features/payment/paymentDefinitions";
import type { HoverIdlePurchasedPermanentItemsState } from "@/features/payment/types";

export interface OwnedPermanentPurchase {
  readonly definition: PermanentPurchaseDefinition;
  readonly count: number;
}

export interface PermanentPurchaseEffectSummary {
  readonly mpCapacity: number;
  readonly hovGainPercent: number;
  readonly timGainPercent: number;
}

export function listOwnedPermanentPurchases(
  purchasedItems: HoverIdlePurchasedPermanentItemsState,
): readonly OwnedPermanentPurchase[] {
  const owned: OwnedPermanentPurchase[] = [];

  for (const definition of PERMANENT_PURCHASE_DEFINITIONS) {
    const count = purchasedItems[definition.id];
    if (count <= 0) continue;
    owned.push({ definition, count });
  }

  return owned;
}

export function summarizePermanentPurchaseEffects(
  purchasedItems: HoverIdlePurchasedPermanentItemsState,
): PermanentPurchaseEffectSummary {
  let mpCapacity = 0;
  let hovGainPercent = 0;
  let timGainPercent = 0;

  for (const { definition, count } of listOwnedPermanentPurchases(
    purchasedItems,
  )) {
    if (definition.effect.kind === "mpCapacity") {
      mpCapacity += definition.effect.amount * count;
      continue;
    }
    if (definition.effect.kind === "hovGainPercent") {
      hovGainPercent += definition.effect.percent * count;
      continue;
    }
    timGainPercent += definition.effect.percent * count;
  }

  return {
    mpCapacity,
    hovGainPercent,
    timGainPercent,
  };
}
